import { IStoresOriginationRankingResponse } from '@scudraservicos/coordinator-client/dist/src/services/transactions/interfaces/stores-ranking'
import { Box } from 'grommet'
import * as React from 'react'
import { Role } from '../../../../common/constants'
import { getAndFormatGraphXLabels } from '../../../../common/FormatName'
import { hasIdentifiedRetailersDashView } from '../../../../common/RoleValidators'
import { BarChart, Loading } from '../../../../legacy-lib/design-kit-ui'
import { getYValues } from '../../../../legacy-lib/design-kit-ui/BarChart/helpers'
import { blue } from '../../../../legacy-lib/design-kit-ui/Palette'
import {
  ApplicationsByStoreBoxStyle,
  BigCardStyle,
  IconCardStyle,
  SectionTitleStyle,
  SortLeftIconStyled,
  SortRightIconStyled,
  TextStyle,
} from './style'

export interface IOriginationsByStoreComparativeProps {
  originationsRankingByStore?: IStoresOriginationRankingResponse | Error
  originationsRankingByStoreIntervalBefore?: IStoresOriginationRankingResponse | Error
  stringDate?: string
  intervalBeforeStringDate?: string
  userRole?: Role
}

export interface IOriginationsByStoreComparativeState {
  isOnRankingOrder: boolean
}

const initialState: IOriginationsByStoreComparativeState = {
  isOnRankingOrder: false,
}

export default class OriginationsByStoreComparative extends React.Component<
  IOriginationsByStoreComparativeProps,
  IOriginationsByStoreComparativeState
> {
  _isMounted = false

  constructor(props: IOriginationsByStoreComparativeProps) {
    super(props)

    this.state = initialState
  }

  orderValues = () => {
    const { isOnRankingOrder } = this.state

    this.setState({
      isOnRankingOrder: !isOnRankingOrder,
    })
  }

  public render() {
    const { isOnRankingOrder } = this.state
    const {
      originationsRankingByStore,
      originationsRankingByStoreIntervalBefore,
      stringDate,
      intervalBeforeStringDate,
    } = this.props

    const maxValueData =
      (originationsRankingByStore &&
        !(originationsRankingByStore instanceof Error) &&
        originationsRankingByStore.storesRanking.reduce((a, b) => (a.principalSum > b.principalSum ? a : b))
          .principalSum) ||
      0

    const maxValueComparisonData =
      (originationsRankingByStoreIntervalBefore &&
        !(originationsRankingByStoreIntervalBefore instanceof Error) &&
        originationsRankingByStoreIntervalBefore.storesRanking.length > 0 &&
        originationsRankingByStoreIntervalBefore.storesRanking.reduce((a, b) =>
          a.principalSum > b.principalSum ? a : b
        ).principalSum) ||
      0

    const showBarChart =
      originationsRankingByStore instanceof Error || originationsRankingByStoreIntervalBefore instanceof Error ? (
        <TextStyle color="red">{'Não foi possível carregar os dados. Tente novamente.'}</TextStyle>
      ) : (
        originationsRankingByStore &&
        originationsRankingByStoreIntervalBefore &&
        maxValueData !== undefined &&
        maxValueComparisonData !== undefined && (
          <BarChart
            isCurrency
            boundsLabels={{ y: 'Valor R$' }}
            yAxis={getYValues(
              0,
              maxValueData > maxValueComparisonData ? maxValueData * 1.2 : maxValueComparisonData * 1.2
            )}
            averageValue={Number(originationsRankingByStore.averageVolumeOriginations.toFixed())}
            data={originationsRankingByStore.storesRanking
              .sort((a, b) => (isOnRankingOrder ? a.principalSum - b.principalSum : b.principalSum - a.principalSum))
              .map(store => ({
                value: Number(store.principalSum.toFixed()),
                label:
                  this.props.userRole && hasIdentifiedRetailersDashView(this.props.userRole)
                    ? `${getAndFormatGraphXLabels(store.storeName)}`
                    : `Loja ${store.rankingPosition}`,
                topLabel: stringDate,
              }))}
            comparisonData={originationsRankingByStoreIntervalBefore.storesRanking
              .sort((a, b) => (isOnRankingOrder ? a.principalSum - b.principalSum : b.principalSum - a.principalSum))
              .map(store => ({
                value: Number(store.principalSum.toFixed()),
                topLabel: intervalBeforeStringDate,
              }))}
          />
        )
      )

    return (
      <ApplicationsByStoreBoxStyle>
        <Box direction="row" justify="between" align="end">
          <Box>
            <SectionTitleStyle>Comparativo de compras</SectionTitleStyle>
            <TextStyle>As informações do gráfico abaixo são de acordo com o filtro do calendário.</TextStyle>
          </Box>
          <IconCardStyle onClick={this.orderValues}>
            {isOnRankingOrder ? <SortLeftIconStyled color={blue.vivid} /> : <SortRightIconStyled color={blue.vivid} />}
          </IconCardStyle>
        </Box>
        <BigCardStyle>
          {originationsRankingByStore && originationsRankingByStoreIntervalBefore ? (
            <Box>{showBarChart}</Box>
          ) : (
            <Box fill align="center" justify="center">
              <Loading></Loading>
            </Box>
          )}
        </BigCardStyle>
      </ApplicationsByStoreBoxStyle>
    )
  }
}
